<template>
  <el-menu 
    :default-active="this.path" 
    router 
    :collapse="isCollapse" 
    :collapse-transition="true" 
    class="sidebar-menu"
    unique-opened
    @select="onMenuSelect"
  >
    <div class="logo-container">
      <img alt="" src="@/assets/images/WechatIMG200.png" class="logo-img">
      <span v-if="!isCollapse" class="logo-text">宿舍管理系统</span>
    </div>
    
    <el-menu-item index="/home">
      <el-icon><house /></el-icon>
      <span>首页</span>
    </el-menu-item>
    
    <el-sub-menu v-if="this.judgeIdentity() !== 0 && this.judgeIdentity() !== 3" index="2">
      <template #title>
        <el-icon><user /></el-icon>
        <span>用户管理</span>
      </template>
      <el-menu-item v-if="this.judgeIdentity() !== 0" index="/stuInfo">学员信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity()===2" index="/dormManagerInfo">宿管信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity()===2" index="/approverInfo">审批员信息</el-menu-item>
    </el-sub-menu>
    
    <el-sub-menu v-if="this.judgeIdentity() !== 0 && this.judgeIdentity() !== 3" index="3">
      <template #title>
        <el-icon><coin /></el-icon>
        <span>宿舍管理</span>
      </template>
      <el-menu-item v-if="this.judgeIdentity() === 2" index="/buildingInfo">楼宇信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() !== 0" index="/roomInfo">房间信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() !== 0" index="/roomPanel">房间面板</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() !== 0" index="/roomStatus">房态管理</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() === 2" index="/roomCalendar">日历视图</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() === 2" index="/roomBooking">房间预订</el-menu-item>
    </el-sub-menu>
    
    <el-sub-menu v-if="this.judgeIdentity() !== 0" index="4">
      <template #title>
        <el-icon><message /></el-icon>
        <span>信息管理</span>
      </template>
      <el-menu-item v-if="this.judgeIdentity() === 2" index="/noticeInfo">公告信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() === 2" index="/classInfo">班级管理</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() !== 0 && this.judgeIdentity() !== 3" index="/repairInfo">报修信息</el-menu-item>
      <el-menu-item v-if="this.judgeIdentity() !== 0" index="/changeRoomApproval">调宿审批</el-menu-item>
    </el-sub-menu>
    
    <el-menu-item v-if="this.judgeIdentity() === 2" index="/visitorInfo">
      <el-icon><View /></el-icon>
      <span>访客管理</span>
    </el-menu-item>
    
    <el-menu-item v-if="this.judgeIdentity() === 2" index="/materiel">
      <el-icon><Box /></el-icon>
      <span>物料管理</span>
    </el-menu-item>

    <el-menu-item v-if="this.judgeIdentity() === 2" index="/dataBackup">
      <el-icon><FolderChecked /></el-icon>
      <span>数据备份</span>
    </el-menu-item>

    <el-menu-item v-if="this.judgeIdentity() === 0" index="/myRoomInfo">
      <el-icon><school /></el-icon>
      <span>我的宿舍</span>
    </el-menu-item>
    
    <el-menu-item v-if="this.judgeIdentity() === 0" index="/applyChangeRoom">
      <el-icon><takeaway-box /></el-icon>
      <span>申请调宿</span>
    </el-menu-item>
    
    <el-menu-item v-if="this.judgeIdentity() === 0" index="/applyRepairInfo">
      <el-icon><set-up /></el-icon>
      <span>报修申请</span>
    </el-menu-item>
    
    <el-menu-item index="/selfInfo">
      <el-icon><setting /></el-icon>
      <span>个人信息</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import request from "@/utils/request";
import { ElMessage } from "element-plus";

export default {
  name: "Aside",
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close-mobile'],
  data() {
    return {
      user: {},
      identity: '',
      path: this.$route.path
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      request.get("/main/loadIdentity").then((res) => {
        if (res.code !== "0") {
          ElMessage({
            message: '用户会话过期',
            type: 'error',
          });
          sessionStorage.clear()
          request.get("/main/signOut");
        }
        window.sessionStorage.setItem("identity", res.data);
        this.identity = res.data
      });
      request.get("/main/loadUserInfo").then((result) => {
        if (result.code !== "0") {
          ElMessage({
            message: '用户会话过期',
            type: 'error',
          });
          request.get("/main/signOut");
          sessionStorage.clear()
          this.$router.replace({ path: "/login" });
        }
        window.sessionStorage.setItem("user", JSON.stringify(result.data));
        this.user = result.data
      });
    },
    judgeIdentity() {
      if (this.identity === 'student') {
        return 0
      } else if (this.identity === 'dormManager') {
        return 1
      } else if (this.identity === 'approver') {
        return 3
      } else {
        return 2
      }
    },
    onMenuSelect() {
      // 移动端点击菜单后关闭侧边栏
      this.$emit('close-mobile');
    }
  },
  watch: {
    $route(to) {
      this.path = to.path;
    }
  }
}
</script>

<style scoped>
.sidebar-menu {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 40px);
  border-right: none;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  border-bottom: 1px solid #e4e7ed;
}

.logo-img {
  width: 40px;
  height: 40px;
  transition: width 0.3s;
}

.logo-text {
  font-size: 16px;
  font-weight: bold;
  color: #409eff;
  margin-left: 10px;
  white-space: nowrap;
}

.el-sub-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 199px;
}

/* 折叠状态 */
.el-menu--collapse .logo-container {
  padding: 10px 0;
}

.el-menu--collapse .logo-img {
  width: 32px;
}

.el-menu--collapse .logo-text {
  display: none;
}

/* 移动端样式 */
@media screen and (max-width: 767px) {
  .sidebar-menu {
    min-height: 100vh;
  }
  
  .logo-container {
    padding: 12px 0;
  }
  
  .logo-img {
    width: 36px;
  }
  
  .logo-text {
    font-size: 14px;
  }
  
  .el-sub-menu .el-menu-item {
    height: 45px;
    line-height: 45px;
    padding: 0 40px;
    min-width: 180px;
  }
}

/* 平板端 */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .logo-text {
    font-size: 14px;
  }
  
  .el-sub-menu .el-menu-item {
    min-width: 179px;
  }
}
</style>